import { green } from '../colors';
export const successColor = (mode)=>{
    return mode === 'light' ? {
        main: green[500],
        highContrast: green[700],
        lowContrast: green[100]
    } : {
        main: green[400],
        highContrast: green[100],
        lowContrast: green[800]
    };
};

//# sourceMappingURL=success.js.map